import cx from 'classnames'
import React from 'react'

export function H4({ children, className }: { children: React.ReactNode; className?: string }) {
  return <h4 className={cx('text-base font-semibold font-aspekta', className)}>{children}</h4>
}

export function H3({ children, className }: { children: React.ReactNode; className?: string }) {
  return <h3 className={cx('text-lg font-semibold font-aspekta', className)}>{children}</h3>
}

export function H2({ children, className }: { children: React.ReactNode; className?: string }) {
  return <h2 className={cx('text-xl font-semibold font-aspekta', className)}>{children}</h2>
}

export function H1({ children, className }: { children: React.ReactNode; className?: string }) {
  return <h1 className={cx('text-2xl font-bold font-aspekta', className)}>{children}</h1>
}
